<template>
  <section id="accounting" class="accounting">
    <div class="section-top-row">
      <div class="row row-narrow align-items-center no-print position-relative">
        <div class="col order-md-0 order-0">
          <h1 v-if="$route.name === 'AccountingMain'">{{ $t('accounting') }}</h1>
          <h1 v-else class="d-flex flex-row gap-2">
            <div class="d-md-inline d-none">
              <router-link :to="{ name: 'AccountingMain' }">{{ $t('accounting') }}</router-link>
            </div>
            <div class="d-md-inline d-none">/</div>
            <AccountingMonthSwitch :month="month" v-if="month"/>
          </h1>
        </div>
        <div class="col-auto order-md-2 mt-md-0 mt-2 order-4 table-view-navigator"
             v-if="showFilter">
          <DataTableFilterButton/>
        </div>
        <div class="col-auto table-view-navigator order-md-4 order-1">
          <DataTableExcel/>
        </div>
        <div class="col-auto order-md-5 order-2 table-view-navigator">
          <AddObject module="accounting"/>
        </div>
      </div>
    </div>
    <router-view/>
  </section>
</template>

<script setup>
import AddObject from "@/components/parts/datatable/AddObject"
import DataTableExcel from "@/components/parts/datatable/DataTableExcel"
import { computed } from "vue"
import { useStore } from "vuex"
import AccountingMonthSwitch from "@/components/parts/accounting/AccountingMonthSwitch.vue"
import DataTableFilterButton from "@/components/parts/datatable/DataTableFilterButton.vue"
import {useRoute} from "vue-router"

const store = useStore()

const month = computed(() => store.state.accounting.accountingmonth)

const route = useRoute()

const routeName = computed(() => route.name)

const showFilter = computed(() => ['AccountingMonthOtherIncome', 'AccountingMonthOtherExpense'].includes(routeName.value))
</script>
